import ErrorRoutes from '@app/Views/Errors';
import WelcomeFlow from "@app/WelcomeFlow";
import MyGarage from "@app/MyGarage";
import MyMarketplace from "@app/MyMarketplace";
import Safety from "@app/Safety";
import Booking from "@app/Views/Booking";
import Carbucks from "@app/Carbucks";
import DealerModeRoutes from "@app/DealerMode";
import DebugRoutes from "@app/Views/Debug";

import { NavigationConfig } from '@library/Services/Navigation';
export const navigation = new NavigationConfig();

export const routes = [
    ...MyGarage,
    ...MyMarketplace,
    ...Carbucks,
    ...WelcomeFlow,
    Booking,
    Safety,
    ...DealerModeRoutes,
    ...DebugRoutes,
    ...ErrorRoutes
];

